import { themes } from "@probeton/style";

export default themes.dark;
